import React, { useEffect, useState } from 'react';

const BannerMetadata = () => {
  const [bannerMetadata, setBannerMetadata] = useState(null);

  useEffect(() => {
    const handler = event => {
      const whitelistOrigins = [
        'http://localhost:3003',
        'https://enhanced-ads.nativeadvertising.com',
        'http://enhanced-ads.nativeadvertising.com',
        'https://generator.sharethrough.com',
        'http://generator.sharethrough.com'
      ];
      if (
        whitelistOrigins.indexOf(event.origin) === -1 ||
        !event.data ||
        event.data.key !== 'BannerMetadata'
      ) {
        return;
      }
      setBannerMetadata(event.data.payload);
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  return (
    bannerMetadata && (
      <div
        className={`mb2 notif ${
          bannerMetadata.clickable ? 'notif-success' : 'notif-error'
        }`}
      >
        {`"${bannerMetadata.bannerType}" banner is ${
          bannerMetadata.clickable ? 'clickable' : 'not clickable'
        }`}
      </div>
    )
  );
};

export default BannerMetadata;
